import type { StudioPresence } from '@hive/shared';
import { MemberAvatar } from '@/components/MemberAvatar';
import { cn } from '@/lib/utils';
import type { PresenceStatus } from '@/presence/useStudioPresence';

const STATUS_TEXT: Record<PresenceStatus, string> = {
  connecting: 'Connecting',
  live: 'Online',
  offline: 'Presence offline',
};

/** Who's in the studio right now, from the "studio" presence channel. */
export function OnlineList({
  online,
  status,
  selfId,
}: {
  online: StudioPresence[];
  status: PresenceStatus;
  selfId: string;
}) {
  return (
    <section aria-label="Online" className="flex items-center gap-3">
      <span
        className={cn(
          'flex items-center gap-2 font-mono text-[10px] tracking-[0.12em] uppercase',
          status === 'live' ? 'text-green' : status === 'offline' ? 'text-red' : 'text-muted',
        )}
      >
        <span className="size-1.5 bg-current shadow-[0_0_6px_currentColor]" aria-hidden />
        {STATUS_TEXT[status]}
        {status === 'live' ? ` · ${online.length}` : null}
      </span>
      <ul className="flex items-center gap-2">
        {online.map((p) => (
          <li key={p.member_id} className="flex items-center gap-1.5" title={p.display_name}>
            <span className="relative">
              <MemberAvatar name={p.display_name} avatarUrl={p.avatar_url} className="size-6" />
              <span
                className="absolute -right-0.5 -bottom-0.5 size-2 rounded-full border border-bg bg-green shadow-glow-green"
                aria-hidden
              />
            </span>
            <span className="hidden text-sm font-semibold sm:inline">
              {p.display_name}
              {p.member_id === selfId ? <span className="text-muted"> (you)</span> : null}
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}
